export enum ApplicationRole {
  user,
  administrator
}
